import React from "react";
import { FormattedMessage } from "react-intl";
export var LibraryReference = function (_a) {
    var name = _a.name, status = _a.status;
    return (React.createElement(React.Fragment, null,
        name,
        status === "DELETED" && (React.createElement(React.Fragment, null,
            " ",
            React.createElement("span", null,
                React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.library.reference.deletedSuffix" }))))));
};
